import { render, staticRenderFns } from "./OptionsInput.vue?vue&type=template&id=55167bb4&scoped=true&"
import script from "./OptionsInput.vue?vue&type=script&lang=js&"
export * from "./OptionsInput.vue?vue&type=script&lang=js&"
import style0 from "./OptionsInput.vue?vue&type=style&index=0&id=55167bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55167bb4",
  null
  
)

export default component.exports